import React from 'react';
import './Footer.css';

const Footer = ({ onNavigate }) => {
  const handleClick = (e, pageId) => {
    if (window.innerWidth > 900) {
      e.preventDefault();
      onNavigate(pageId);
    }
  };

  return (
    <footer className="footer">
      <a href="#home" onClick={(e) => handleClick(e, 'home')}>
        <img src="/images/logo1.png" alt="AG Health Counseling" className="footer-logo" />
      </a>
      <ul className="footer-links">
        {[
          { id: 'about',    label: 'About' },
          { id: 'services', label: 'Services' },
          { id: 'approach', label: 'Approach' },
          { id: 'fees',     label: 'Insurance' },
        ].map(({ id, label }) => (
          <li key={id}>
            <a href={`#${id}`} onClick={(e) => handleClick(e, id)}>{label}</a>
          </li>
        ))}
      </ul>
      <div className="footer-right">
        <a href="tel:6122948303" className="footer-phone">(612) 294-8303</a>
        <span className="footer-copy">© 2026 AG Health Counseling</span>
        <span className="footer-credit">Designed by <a href="https://yulenai.com" target="_blank" rel="noreferrer" className="footer-credit-link">YuLen AI Services</a></span>
      </div>
    </footer>
  );
};

export default Footer;